import * as React from "react";
import { IconProps } from "./types";

export const AlignCenterIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M18 10H6M21 6H3M21 14H3M18 18H6"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(AlignCenterIcon as React.FunctionComponent).displayName = "AlignCenterIcon";

export default AlignCenterIcon;
